import { SelectboxOptionType } from '@/shared/components/Common/form/AutocallSelector'

export const bankOptions: SelectboxOptionType[] = [
  { label: '기업은행', value: 1 },
  { label: '국민은행', value: 2 },
  { label: '신한은행', value: 3 },
  { label: '우리은행', value: 4 },
  { label: 'KEB하나은행', value: 5 },
  { label: '농협은행', value: 6 },
  { label: '지역농축협', value: 7 },
  { label: 'SC제일은행', value: 8 },
  { label: '한국시티은행', value: 9 },
  { label: '우체국', value: 10 },
  { label: '경남은행', value: 11 },
  { label: '광주은행', value: 12 },
  { label: '대구은행', value: 13 },
  { label: '도이치', value: 14 },
  { label: '부산은행', value: 15 },
  { label: '산림조합', value: 16 },
  { label: '산업은행', value: 17 },
  { label: '저축은행', value: 18 },
  { label: '새마을금고', value: 19 },
  { label: '수협', value: 20 },
  { label: '신협', value: 21 },
  { label: '전북은행', value: 22 },
  { label: '제주은행', value: 23 },
  { label: 'BOA', value: 24 },
  { label: 'HSBC', value: 25 },
  { label: 'JP모간', value: 26 },
  { label: '중국공상은행', value: 27 },
  { label: '비엔피파리바은행', value: 28 },
  { label: '중국건설은행', value: 29 },
  { label: '카카오뱅크', value: 30 },
  { label: '케이뱅크', value: 31 },
  { label: '교보증권', value: 32 },
  { label: '대신증권', value: 33 },
  { label: '미래에셋대우', value: 34 },
  { label: 'DB금융투자', value: 35 },
  { label: '유안타증권', value: 36 },
  { label: '메리츠증권', value: 37 },
  { label: '부국증권', value: 38 },
  { label: '삼성증권', value: 39 },
  { label: '솔로몬투자증권', value: 40 },
  { label: '신영증권', value: 41 },
  { label: '신한금융투자', value: 42 },
  { label: 'NH투자증권', value: 43 },
  { label: '유진투자증권', value: 44 },
  { label: '이베스트증권', value: 45 },
  { label: '키움증권', value: 46 },
  { label: '하나금융투자', value: 47 },
  { label: '하이투자', value: 48 },
  { label: '한국투자', value: 49 },
  { label: '한화증권', value: 50 },
  { label: 'KB증권', value: 51 },
  { label: '현대차투자증권', value: 52 },
  { label: '토스뱅크', value: 53 },
  { label: '케이프투자증권', value: 54 },
  { label: 'SK증권', value: 55 },
  { label: 'KTB투자증권', value: 56 },
  { label: '한국포스증권', value: 57 },
]
